const NUMERIC_VERSION = /^\d+(\.\d+)*$/;

const isNumericVersion = value => NUMERIC_VERSION.test(value || "");

const compareNumericVersions = (a, b) => {
  const left = a.split(".").map(Number);
  const right = b.split(".").map(Number);
  const length = Math.max(left.length, right.length);

  for (let i = 0; i < length; i += 1) {
    const diff = (left[i] || 0) - (right[i] || 0);
    if (diff !== 0) return diff;
  }

  return 0;
};

export const isNewerVersion = (version, other) => {
  if (!isNumericVersion(version) || !isNumericVersion(other)) return false;
  return compareNumericVersions(version, other) > 0;
};
